export const LimitStatus = ["ACTIVE", "BLOCKED", "CLOSED"] as const;
export type LimitStatusType = (typeof LimitStatus)[number];

export interface ILimit {
  contractId?: string;
  creditorAppId?: string;
  brokerAppId?: string;
  amount?: string;
  balance?: string;
  hold?: string;
  cashBalance?: string;
  currency?: string;
  createdAt?: string;
  updatedAt?: string;
  status?: LimitStatusType;
}
